import { render, staticRenderFns } from "./WebRTC.vue?vue&type=template&id=104d2f6e&scoped=true"
import script from "./WebRTC.vue?vue&type=script&lang=js"
export * from "./WebRTC.vue?vue&type=script&lang=js"
import style0 from "./WebRTC.vue?vue&type=style&index=0&id=104d2f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d2f6e",
  null
  
)

export default component.exports